// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__CTliZ","tokenPreview":"styles_tokenPreview__1btbU","tokenIcon":"styles_tokenIcon__L5kzM"};